<template>
  <form @submit.prevent action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Adicionar Transação</p>
      </header>

      <section class="modal-card-body">
        <div class="buttons has-addons">
          <span class="button is-light" :class="{'is-selected is-success': !isExpenditure}" @click="isExpenditure = false">Receita</span>
          <span class="button is-light" :class="{'is-selected is-danger': isExpenditure}" @click="isExpenditure = true">Despesa</span>
        </div>

        <b-field label="Decrição">
          <b-input
            placeholder="Ex.: Pagamento Conta Energia Elétrica"
            v-model="transacao.descricao"
          ></b-input>
        </b-field>

        <div class="tile is-ancestor">
          <div class="tile is-vertical">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child">
                  <b-field label="Categoria da Transação">
                    <b-select placeholder="Select a name" v-model="transacao.tipo" expanded>
                      <option
                        v-for="option in this.$store.getters['associacao/getAssociacao'].categorias_transacoes"
                        :value="option"
                        :key="option"
                      >{{ option }}</option>
                    </b-select>
                  </b-field>
                </article>

                <article class="tile is-child">
                  <b-field label="Valor">
                    <money
                      v-model="transacao.valor"
                      v-bind="money"
                      class="input form-input input-lg"
                    >{{transacao.valor}}</money>
                  </b-field>
                </article>
              </div>

              <div class="tile is-parent is-vertical">
                <article class="tile is-child">
                  <b-field label="Selecione a Conta">
                    <b-select placeholder="Contas" v-model="transacao._conta" expanded>
                      <option
                        v-for="conta in this.$store.getters['contas/getContas']"
                        :value="conta._id"
                        v-bind:key="conta._id"
                      >{{conta.nome}}</option>
                    </b-select>
                  </b-field>
                </article>

                <article class="tile is-child">
                  <b-field label="Data da Transação">
                    <b-datepicker
                      v-model="transacao.data"
                      placeholder="Clique para selecionar..."
                      icon="calendar-today"
                      position="is-top-left"
                      :month-names="monthNames"
                      :day-names="dayNames"
                    ></b-datepicker>
                  </b-field>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button
          class="button is-success is-small"
          @click="saveTransaction(false)"
          :disabled="!this.transacao._conta"
        >Salvar</button>
        <button
          class="button is-primary is-small"
          @click="saveTransaction(true)"
          :disabled="!this.transacao._conta"
        >Salvar e Sair</button>
        <button class="button is-danger is-small" @click="closeModal()">Cancelar</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      date: new Date(),
      monthNames: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      dayNames: ["D", "S", "T", "Q", "Q", "S", "S"],
      contas: [],
      isEmpty: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " #",
        precision: 2,
        masked: false
      },
      transacao: {
        _id: "",
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _conta: "",
        _responsavel: this.$cookies.get("USERTOKEN"),
        data: null,
        valor: 0.0,
        tipo: "",
        descricao: "",
        allowedErase: true,
        isAdjust: false
      },
      disableButton: false,
      isExpenditure: false,
      isClose: false
    };
  },
  computed: {
    successAddTransacao() {
      return this.$store.getters["transacao/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    saveTransaction(isClose) {
      let error = this.validateTransaction();
      this.isClose = isClose;

      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }

      this.saveTransactionOnDatabase();
    },

    validateTransaction() {
      if (!this.transacao.descricao.trim()) return "Adicione uma Descrição!";
      if (!this.transacao.tipo) return "Selecione o Tipo de Transação!";
      if (!this.transacao.data) return "Adicione uma Data!";
      if (this.transacao.valor > 1*10e8) return "Permitido Transações de até 1 Bilhão!";
      if (this.transacao.valor < -1*10e8) return "Permitido Transações de até 1 Bilhão!";
      return;
    },

    async saveTransactionOnDatabase() {
      const loadingComponent = this.$loading.open({
        container: null
      });

      this.transacao._id = this.stringRandomId(20);

      // Grante que o valor seja positivo ou negativo se for receita ou despesa, respectivamente
      if (this.isExpenditure && this.transacao.valor > 0) {
          this.transacao.valor = this.transacao.valor * (-1)
      } else if (!this.isExpenditure && this.transacao.valor < 0) {
          this.transacao.valor = this.transacao.valor * (-1)
      }

      await this.$store.dispatch("transacao/saveTransacaoInFirestore", this.transacao);

      loadingComponent.close();

      if (this.successAddTransacao) {
        this.$alert("Sucesso!", "Transação Adicionada!", "success");
        this.$store.commit("transacao/setIsSuccess", false);
        this.$store.dispatch("transacao/getTransacoesInFirestore");
        if (this.isClose) this.closeModal();
        this.resetarValores();
      } else {
        this.$alert("Erro!", "Erro ao Salvar Transação!", "danger");
      }
    },

    stringRandomId(tamanho) {
      let letras = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      let aleatorio = "";
      for (var i = 0; i < tamanho; i++) {
        var rnum = Math.floor(Math.random() * letras.length);
        aleatorio += letras.substring(rnum, rnum + 1);
      }
      return aleatorio;
    },

    resetarValores() {
      this.transacao = {
        _id: "",
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        _conta: "",
        _responsavel: this.$cookies.get("USERTOKEN"),
        data: null,
        valor: 0.0,
        tipo: "",
        descricao: "",
        allowedErase: true,
        isAdjust: false
      };
    }
  }
};
</script>

<style scoped>
.modal .animation-content .modal-card {
  overflow: visible !important;
}

.modal-card-body {
  overflow: visible !important;
}

.buttons {
  margin: 0;
  justify-content: center;
}

@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll!important;
  }
}
</style>
